// import { upload } from '@testing-library/user-event/dist/upload.js';
// import API from './axios.js';

// export const getAddedDocs = (courtref) =>API.get(`document/${courtref}`);
// export const getMyDocs = (courtref) =>API.get(`my-document/by-court-ref/${courtref}`);
// export const getClientsByCases = (courtref) =>API.get(`case/client/${courtref}`);

// export const getAddDocDetailByID = (id) =>API.get(`document/individual/${id}`);


// export const RequestClientHighCourt = (payload) =>API.post(`document/ask-to-upload-in-high-court`,payload)
// export const RequestClientDistrictCourt = (payload) =>API.post(`document/ask-to-upload-in-district-court`,payload)



// export const uploadPendingAddDoc = (payload,documentID) => API.put(`document/${documentID}`,payload)


// export const deleteMyDoc = (documentID) => API.delete(`my-document/${documentID}`)
// export const createMyDoc = (payload) => API.post(`my-document`,payload)

// ../../services/api/AddDocApi.js
import { upload } from '@testing-library/user-event/dist/upload.js';
import API from './axios.js';

// ====== EXISTING APIs (Unchanged) ======
export const getAddedDocs = (courtref) => API.get(`document/${courtref}`);
// export const getMyDocs = (courtref) => API.get(`my-document/by-court-ref/${courtref}`);
export const getClientsByCases = (courtref) => API.get(`case/client/${courtref}`);

export const getAddDocDetailByID = (id) => API.get(`document/individual/${id}`);

export const RequestClientHighCourt = (payload) => API.post(`document/ask-to-upload-in-high-court`, payload);
export const RequestClientDistrictCourt = (payload) => API.post(`document/ask-to-upload-in-district-court`, payload);
export const RequestClientSupremeCourt = (payload) => API.post(`document/ask-to-upload-in-supreme-court`, payload);

export const uploadPendingAddDoc = (payload, documentID) => API.put(`document/${documentID}`, payload);

// export const deleteMyDoc = (documentID) => API.delete(`my-document/${documentID}`);
// export const createMyDoc = (payload) => API.post(`my-document`, payload);

// ====== NEW DIRECTORY STRUCTURE APIs ======

// Create file in directory structure
export const createFile = async (payload) => {
  return API.post('/my-document/file', {
    name: payload.name,
    courtRef: payload.courtRef,
    url: payload.url || '',
    parentId: payload.parentId || null,
    size: payload.size || 0,
    mimeType: payload.mimeType || '',
    metadata: payload.metadata || {}
  });
};

// Create folder in directory structure
export const createFolder = async (payload) => {
  return API.post('/my-document/folder', {
    name: payload.name,
    courtRef: payload.courtRef,
    parentId: payload.parentId || null
  });
};

// Get complete directory tree
export const getDirectoryTree = async (courtRef) => {
  return API.get(`/my-document/tree/${courtRef}`);
};

// Move document/folder to another location
export const moveDocument = async (documentId, targetParentId) => {
  return API.patch(`/my-document/${documentId}/move`, {
    targetParentId: targetParentId || 'null'
  });
};

// Permanently delete document/folder
export const deleteDocument = async (documentId) => {
  return API.delete(`/my-document/${documentId}/permanent`);
};

// Get documents by court ref with directory structure (if you want to use this instead of getMyDocs)
export const getDocumentsByCourtRef = async (courtRef, queryParams = {}) => {
  const params = new URLSearchParams();
  
  if (queryParams.parentId) params.append('parentId', queryParams.parentId);
  if (queryParams.type) params.append('type', queryParams.type);
  if (queryParams.search) params.append('search', queryParams.search);
  if (queryParams.page) params.append('page', queryParams.page);
  if (queryParams.limit) params.append('limit', queryParams.limit);
  if (queryParams.sortBy) params.append('sortBy', queryParams.sortBy);
  if (queryParams.sortOrder) params.append('sortOrder', queryParams.sortOrder);

  const queryString = params.toString();
  const url = `/my-document/by-court-ref/${courtRef}${queryString ? `?${queryString}` : ''}`;
  
  return API.get(url);
};

// Search documents and folders
export const searchDocuments = async (courtRef, searchTerm, queryParams = {}) => {
  const params = new URLSearchParams();
  params.append('q', searchTerm);
  
  if (queryParams.type) params.append('type', queryParams.type);
  if (queryParams.page) params.append('page', queryParams.page);
  if (queryParams.limit) params.append('limit', queryParams.limit);
  if (queryParams.sortBy) params.append('sortBy', queryParams.sortBy);
  if (queryParams.sortOrder) params.append('sortOrder', queryParams.sortOrder);

  const queryString = params.toString();
  return API.get(`/my-document/search/${courtRef}?${queryString}`);
};

// ====== UTILITY FUNCTIONS ======

// Helper function to extract filename from URL
export const extractFilenameFromUrl = (url) => {
  if (!url) return 'untitled';
  
  try {
    const urlParts = url.split('/');
    const lastPart = urlParts[urlParts.length - 1];
    const cleanFilename = lastPart.split('?')[0]; // Remove query parameters
    return cleanFilename || 'untitled';
  } catch (error) {
    return 'untitled';
  }
};

// Helper function to get MIME type from file extension
export const getMimeTypeFromFilename = (filename) => {
  if (!filename) return '';
  
  const extension = filename.split('.').pop()?.toLowerCase();
  
  const mimeTypes = {
    // Documents
    'pdf': 'application/pdf',
    'doc': 'application/msword',
    'docx': 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'xls': 'application/vnd.ms-excel',
    'xlsx': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'ppt': 'application/vnd.ms-powerpoint',
    'pptx': 'application/vnd.openxmlformats-officedocument.presentationml.presentation',
    
    // Images
    'jpg': 'image/jpeg',
    'jpeg': 'image/jpeg',
    'png': 'image/png',
    'gif': 'image/gif',
    'bmp': 'image/bmp',
    'webp': 'image/webp',
    
    // Text
    'txt': 'text/plain',
    'csv': 'text/csv',
    
    // Archives
    'zip': 'application/zip',
    'rar': 'application/x-rar-compressed',
    '7z': 'application/x-7z-compressed',
  };
  
  return mimeTypes[extension] || '';
};

// Helper function to get file size (if available from Firebase or other sources)
export const getFileSizeFromResponse = (uploadResponse) => {
  // This depends on your Firebase uploader response structure
  // Adjust according to your FirebaseUploader component's response
  return uploadResponse?.size || uploadResponse?.metadata?.size || 0;
};

// Helper function to format file size
export const formatFileSize = (bytes) => {
  if (!bytes || bytes === 0) return '0 KB';
  const k = 1024;
  const sizes = ['Bytes', 'KB', 'MB', 'GB'];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
};

// ====== BACKWARD COMPATIBILITY HELPERS ======

// Legacy createMyDoc wrapper that uses new directory structure
export const createMyDocLegacy = async (payload) => {
  // Convert legacy payload to new structure
  const filename = extractFilenameFromUrl(payload.url);
  
  return createFile({
    name: filename,
    courtRef: payload.courtRef,
    url: payload.url,
    parentId: payload.parentId || null,
    size: payload.size || 0,
    mimeType: getMimeTypeFromFilename(filename),
    metadata: payload.metadata || {
      legacyUpload: true,
      uploadedAt: new Date().toISOString()
    }
  });
};

// Legacy deleteMyDoc that uses permanent delete
export const deleteMyDocLegacy = async (documentID) => {
  return deleteDocument(documentID);
};